import { render, staticRenderFns } from "./ModalMassiveSupervisorAssignment.vue?vue&type=template&id=28145d78&scoped=true&"
import script from "./ModalMassiveSupervisorAssignment.vue?vue&type=script&lang=js&"
export * from "./ModalMassiveSupervisorAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ModalMassiveSupervisorAssignment.vue?vue&type=style&index=0&id=28145d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28145d78",
  null
  
)

export default component.exports